import { getPermittedOutsideNetworks } from '.';

function canReferOutOfNetwork(scopes, networkId) {
  return getPermittedOutsideNetworks(scopes, networkId).length > 0;
}

export default canReferOutOfNetwork;
